export const getAriaLive = (state) => state?.aria?.live
